import { getUnit, kmToMiles } from 'lib/geo/distanceUnits'

export function getSearchDistanceLabel(searchTargetLabel: string, distanceMeters: number, regionCode: string) {
  const unit = getUnit(regionCode)

  // For metric regions, show sub-kilometre distances in metres (e.g. "900 m"), rounded to the nearest 10m.
  if (unit === 'km' && distanceMeters < 1000) {
    const displayMetres = Math.round(distanceMeters / 10) * 10
    return `${displayMetres} m from ${searchTargetLabel}`
  }

  const km = distanceMeters / 1000
  const unitDistance = unit === 'km' ? km : kmToMiles(km)
  const precision = km < 0.5 ? 2 : 1
  const displayNumber = unitDistance.toFixed(precision)
  return unit === 'km' ? `${displayNumber} km from ${searchTargetLabel}` : `${displayNumber} mi from ${searchTargetLabel}`
}
